import React from "react"
import { simpleReplacePlaceholders } from "QuorumGrassroots/helperFunctions"
import {
    TitleSubtitleStack,
    Title,
    Subtitle,
    BackgroundImage,
} from "QuorumGrassroots/campaign-forms/components/GotvV2Form/components/CampaignTitleSubtitle/CampaignTitleSubtitle.styles"
import { Campaign } from "@/types/djangio"

interface CampaignTitleSubtitleProps {
    campaign: Campaign
}

const DEFAULT_TITLE = "Get Out The Vote! #GOTV"
const DEFAULT_DESCRIPTION = "Make a huge impact voting in Election Day!"

export const CampaignTitleSubtitle: React.FC<CampaignTitleSubtitleProps> = ({ campaign }) => {
    const userdata = window?.userdata ?? {}

    return (
        <TitleSubtitleStack>
            {campaign?.background_image && (
                <BackgroundImage
                    src={campaign.background_image}
                    alt={campaign.background_image_alt_text ?? "Campaign background image"}
                    data-plum-id="campaign-title-subtitle.background-image"
                />
            )}
            <Title component="h2" data-plum-id="campaign-title-subtitle.title">
                {campaign.name ?? DEFAULT_TITLE}
            </Title>
            {campaign?.long_description ? (
                <Subtitle
                    data-plum-id="campaign-title-subtitle.subtitle"
                    dangerouslySetInnerHTML={{
                        __html: simpleReplacePlaceholders(campaign.long_description, userdata),
                    }}
                />
            ) : (
                <Subtitle data-plum-id="campaign-title-subtitle.subtitle">{DEFAULT_DESCRIPTION}</Subtitle>
            )}
        </TitleSubtitleStack>
    )
}
